import { ReactNode } from 'react'

import { cn } from '@/shared/lib/utils'

interface FooterProps {
  id?: string | number
  children: ReactNode
}

export const Footer = ({ id = 'unique', children }: FooterProps) => {
  return (
    <div
      id="level-play-footer"
      className={cn(
        'z-20 flex items-center justify-between gap-4 w-[90%] md:w-[80%] mx-auto p-3 md:p-4 rounded-2xl',
        'bg-white mb-[-30px]',
        'shadow-[0_8px_0_-1px_var(--color-primary)]'
      )}
    >
      {children}
    </div>
  )
}
